import { createSlice } from '@reduxjs/toolkit'
import { LeadStateModel } from 'models/LeadStateModel'
import { SsoLoginInternal } from 'models/LoginResponseModel'
import { TokenHeaderModel } from 'models/TokenHeaderModel'
import { consoleLog } from 'utils/Logger'
import { deleteCookie, getCookie, setCookie } from 'utils/cokie'
import { FakeLeadResponse } from 'utils/fakeres/Res'
import jwt_decode from 'jwt-decode'
import { getApolloAuthClient } from 'graphql/client'
import { REFRESH_TOKEN } from 'graphql/mutation'
import routes from 'routes'
import { Pages } from 'routes/types'
import { getCurrentDate } from 'utils/dateutil'
import moment from 'moment'

const isToken: boolean =
  getCookie('access_token') === null || getCookie('access_token') === 'null' ? false : true
const tokenHEader = isToken ? (jwt_decode(getCookie('access_token')) as TokenHeaderModel) : null
consoleLog('istoken=' + isToken)
consoleLog('istoken=' + getCookie('refresh_token'))

export type InitialState = {
  isLoggedIn: boolean
  LoginData: SsoLoginInternal
  leadState: LeadStateModel
  tokenHeader: TokenHeaderModel
  userEmail: string
  userSignUrl: string
  userSignatureChecked: boolean
  salesUserIdentityType: string
  salesUserIdentityNumber: string
}
const initialState = {
  isLoggedIn: isToken,
  isApiInProgress: false,
  LoginData: {},
  leadState: null,
  tokenHeader: tokenHEader,
  userEmail: localStorage.getItem('user_email') || tokenHEader?.email || '',
  userSignUrl: localStorage.getItem('user_sign_url') || '',
  userSignatureChecked: localStorage.getItem('user_signature_checked') === 'true',
  salesUserIdentityType: localStorage.getItem('sales_user_identity_type') || '',
  salesUserIdentityNumber: localStorage.getItem('sales_user_identity_number') || '',
} as InitialState

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    getLogin: (state, action) => {
      consoleLog(action?.payload)
      if (action?.payload) {
        state.LoginData = action.payload.ssoLoginInternal
      }
      if (action?.payload?.ssoLoginInternal?.refreshToken?.token != null) {
        state.isLoggedIn = true
        setCookie({
          name: 'refresh_token',
          value: action?.payload?.ssoLoginInternal.refreshToken?.token,
          expiryDays: 30,
        })
        setCookie({
          name: 'access_token',
          value: action?.payload?.ssoLoginInternal.accessToken?.token,
          expiryDays: 15,
        })
        setCookie({
          name: 'sf_token',
          value: action?.payload?.ssoLoginInternal.salesForceAccessToken?.token,
          expiryDays: 30,
        })
        const decoded = jwt_decode(
          action?.payload?.ssoLoginInternal?.accessToken?.token,
        ) as TokenHeaderModel
        state.tokenHeader = decoded
        if (decoded?.email) {
          state.userEmail = decoded.email
          state.userSignUrl = ''
          state.userSignatureChecked = false
          state.salesUserIdentityType = ''
          state.salesUserIdentityNumber = ''
          localStorage.setItem('user_email', decoded.email)
          localStorage.removeItem('user_sign_url')
          localStorage.setItem('user_signature_checked', 'false')
          localStorage.removeItem('sales_user_identity_type')
          localStorage.removeItem('sales_user_identity_number')
        }
        setCookie({
          name: 'emp_id',
          value: decoded?.employeeid,
          expiryDays: 30,
        })

        setCookie({
          name: 'user_type',
          value: decoded?.userType,
          expiryDays: 30,
        })
        setCookie({
          name: 'emp_name',
          value: decoded?.ownername,
          expiryDays: 30,
        })
        setCookie({
          name: 'location_id',
          value: decoded?.locationId,
          expiryDays: 30,
        })
        setCookie({
          name: 'iat',
          value: decoded?.iat,
          expiryDays: 30,
        })
        setCookie({
          name: 'tenantId',
          value: decoded?.tenantId,
          expiryDays: 30,
        })
      }
    },

    loginError: (state, action) => {
      state.isLoggedIn = false
      consoleLog('inside login error')
      deleteCookie({ name: 'refresh_token' })
      deleteCookie({ name: 'access_token' })
      deleteCookie({ name: 'sf_token' })
      deleteCookie({ name: 'emp_id' })
      deleteCookie({ name: 'emp_name' })
      deleteCookie({ name: 'user_type' })
      deleteCookie({ name: 'location_id' })
      deleteCookie({ name: 'iat' })
      deleteCookie({ name: 'tenantId' })
      localStorage.removeItem('timerEntries')
      localStorage.removeItem('user_email')
      localStorage.removeItem('user_sign_url')
      localStorage.removeItem('user_signature_checked')

      state.tokenHeader = null
      state.userEmail = ''
      state.userSignUrl = ''
      state.userSignatureChecked = false
      state.salesUserIdentityType = ''
      state.salesUserIdentityNumber = ''
    },
    leadStateData: (state, action) => {
      state.leadState = action.payload
    },
    setUserSignature: (state, action) => {
      const email = action?.payload?.email || state.userEmail || ''
      const signUrl = action?.payload?.signUrl || ''
      const checked = action?.payload?.checked ?? true
      const identityType = action?.payload?.identityType || state.salesUserIdentityType || ''
      const identityNumber = action?.payload?.identityNumber || state.salesUserIdentityNumber || ''

      state.userEmail = email
      state.userSignUrl = signUrl
      state.userSignatureChecked = checked
      state.salesUserIdentityType = identityType
      state.salesUserIdentityNumber = identityNumber

      if (email) localStorage.setItem('user_email', email)
      else localStorage.removeItem('user_email')

      if (signUrl) localStorage.setItem('user_sign_url', signUrl)
      else localStorage.removeItem('user_sign_url')

      localStorage.setItem('user_signature_checked', String(checked))

      if (identityType) localStorage.setItem('sales_user_identity_type', identityType)
      else localStorage.removeItem('sales_user_identity_type')

      if (identityNumber) localStorage.setItem('sales_user_identity_number', identityNumber)
      else localStorage.removeItem('sales_user_identity_number')
    },

    // getLogout: (state, action) => {
    //   if (action?.payload?.token) {
    //     state.isLoggedIn = false
    //     state.isValidatedToken = false
    //     state.errorMessage = ''
    //   }
    // },
  },
})
export const getLeadState = () => async (dispatch) => {
  try {
    console.log('fakeres == ' + JSON.stringify(FakeLeadResponse))

    // dispatch(leadState(FakeLeadResponse))
  } catch (err) {
    consoleLog('njvj error display' + err)
  }
}
/*
We have to check if day is changed then we want to logout user forcefully
*/
export const checkLoginSession = () => async (dispatch) => {
  try {
    const iat = getCookie('iat')
    const currentDate = getCurrentDate()
    const formattedDate = moment(+iat * 1000).format('YYYY-MM-DD')
    if (formattedDate !== currentDate) {
      dispatch(loginError(null))
    }
  } catch (err) {
    consoleLog('njvj error display' + err)
  }
}

export const getAccessTokenNoDispatch = () => {
  return getApolloAuthClient()
    .mutate({
      mutation: REFRESH_TOKEN,
      variables: {
        input: {
          refreshToken: { token: getCookie('refresh_token') },
        },
      },
      context: { isAuthRequired: false },
    })
    .then((response) => {
      // extract your accessToken from your response data and return it
      consoleLog('inside the token refresh response')
      consoleLog('inside the token refresh response=' + response)

      const accessToken = response.data?.ssoLoginInternal?.accessToken?.token
      const refreshToken = response.data?.ssoLoginInternal?.refreshToken?.token

      setCookie({
        name: 'refresh_token',
        value: refreshToken,
        expiryDays: 30,
      })
      setCookie({
        name: 'access_token',
        value: accessToken,
        expiryDays: 15,
      })
      setCookie({
        name: 'sf_token',
        value: response.data?.ssoLoginInternal.salesForceAccessToken?.token,
        expiryDays: 30,
      })
      setCookie({
        name: 'iat',
        value: response.data?.ssoLoginInternal.salesForceAccessToken?.token,
        expiryDays: 30,
      })
      return { accessToken, refreshToken }
    })
}
export const getAccessToken = (dispatch) => {
  return getApolloAuthClient()
    .mutate({
      mutation: REFRESH_TOKEN,
      variables: {
        input: {
          refreshToken: { token: getCookie('refresh_token') },
        },
      },
      context: { isAuthRequired: false },
    })
    .then((response) => {
      // extract your accessToken from your response data and return it
      consoleLog('inside the token refresh response')
      consoleLog('inside the token refresh response=' + response)

      const accessToken = response.data?.ssoLoginInternal?.accessToken?.token
      const refreshToken = response.data?.ssoLoginInternal?.refreshToken?.token

      dispatch(getLogin(response?.data))
      return { accessToken, refreshToken }
    })
}

export const getSalesforceToken = (dispatch, navigate) => {
  return getApolloAuthClient()
    .mutate({
      mutation: REFRESH_TOKEN,
      variables: {
        input: {
          refreshToken: { token: getCookie('refresh_token') },
        },
      },
      context: { isAuthRequired: false },
    })
    .then((response) => {
      const accessToken = response.data?.ssoLoginInternal?.accessToken?.token
      const refreshToken = response.data?.ssoLoginInternal?.refreshToken?.token
      dispatch(getLogin(response?.data))
      return { accessToken, refreshToken }
    })
    .catch((e) => {
      dispatch(loginError(null))
      setTimeout(() => {
        navigate(routes[Pages.Login].path)
      }, 1000)
    })
}
export const { getLogin, loginError, leadStateData, setUserSignature } = authSlice.actions
export const auth = (state) => state.auth.isLoggedIn
export default authSlice.reducer
